import script from "./Root.vue?vue&type=script&lang=ts&setup=true"
export * from "./Root.vue?vue&type=script&lang=ts&setup=true"

import "./Root.vue?vue&type=style&index=0&id=f9b2699e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9b2699e"]])

export default __exports__